@if (companyGroups.indexOf(applicationService.getSelectCompanyGroupCode()) >= 0 && ((companyIds.indexOf(formattedCompanyId) >= 0) || !companyIds.length)) {
  <small [ngClass]="class">
    {{text}}
  </small>
}
